import './App.css';
import Home from './components/Home/Home';
import Features from './components/Features/Features'
import Portfolio from './components/Portfolio/Portfolio';
import Resume from './components/Resume/Resume';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Header from './components/New folder/Header/header';
import { ToastContainer } from 'react-toastify'



function App() {
  return (
    <div className="App">
      
    <Header/>
     <Home/>
      <Features/>
      <Portfolio/>
      <Resume/>
      <Contact/>
     
      <Footer/>
      <ToastContainer />
    </div>
  );
}

export default App;
